import {
  RECOMMENDATIONS_ACTIONS_KEYS,
  RECOMMENDATIONS_GETTERS_KEYS,
  RECOMMENDATIONS_MUTATIONS_KEYS
} from '../recommendations/recommendations.const';

export const NO_RESULTS_MUTATIONS_KEYS = {
  ...RECOMMENDATIONS_MUTATIONS_KEYS,
  clearFallbackFiltersResults: 'clearFallbackFiltersResults',
  setFallbackFiltersResults: 'setFallbackFiltersResults'
} as const;

export const NO_RESULTS_ACTIONS_KEYS = {
  ...RECOMMENDATIONS_ACTIONS_KEYS,
  getFallbackFiltersResults: 'getFallbackFiltersResults'
} as const;

export const NO_RESULTS_GETTERS_KEYS = {
  ...RECOMMENDATIONS_GETTERS_KEYS
} as const;
